import React from 'react';
import {
    
    required,
    TextInput,
    SimpleForm,
    Edit,
    CardActions,
    ListButton, 
    Toolbar, 
    SaveButton,
    TextField,
    showNotification,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none'
     }
 };
 
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UserEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/users'} />
    </CardActions>
);


const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="/users"
            submitOnEnter={true}
        />
    </Toolbar>
);

const validatePassword = (value) => {
    if (!value) {
        return 'Required';
    }
    const minLength = 8;
    const maxLength = 32;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[~!@#$%^*()_\-+={}[\]|:;".,?]/.test(value);
    const invalidChars = /[<>&']/;

    if (value.length < minLength || value.length > maxLength) {
        return 'Password must be between 8 and 32 characters';
    }
    if (!hasUpperCase) {
        return 'Password must include at least one uppercase letter';
    }
    if (!hasLowerCase) {
        return 'Password must include at least one lowercase letter';
    }
    if (!hasNumber) {
        return 'Password must include at least one number';
    }
    if (!hasSpecialChar) {
        return 'Password must include at least one special character';
    }
    if (invalidChars.test(value)) {
        return 'Password contains invalid characters';
    }
    return undefined;
};

const PasswordEdit = ({ classes, ...props }) => (
    <Edit actions={<UserEditActions />}   {...props} title="Password reset" >
        <SimpleForm toolbar={<UserCreateToolbar />} >
            <TextField source="user_name"    label="Login ID" />
            <TextInput source="password"    label="Password" validate={validatePassword} type="password"/>
            <TextField source="first_name" lable="First Name" formClassName={classes.inlineBlock}/>
            <TextField source="last_name"   label="Last Name"  formClassName={classes.inlineBlock} />
        </SimpleForm>
    </Edit>
);

export default withStyles(styles)(PasswordEdit);
